import React, { useMemo } from 'react';

import {
  DangerAlert,
  DangerAlertProps,
  InfoAlert,
  InfoAlertProps,
  WarningAlert,
  WarningAlertProps,
} from '@tmapy/style-guide';
import { MonitoringLogRowResponse } from '../../openapi/types';

type LogAlertProps = {
  log?: MonitoringLogRowResponse;
};

type AlertData = {
  AlertComponent: React.FC<InfoAlertProps | DangerAlertProps | WarningAlertProps>;
  message: string;
} | null;

export const LogAlert: React.FC<LogAlertProps> = ({ log }) => {
  const data: AlertData = useMemo(() => {
    if (!log?.message) return null;

    let AlertComponent: React.FC<InfoAlertProps | DangerAlertProps | WarningAlertProps>;
    switch (log.level) {
      case 'INFO':
        AlertComponent = InfoAlert;
        break;
      case 'ERROR':
      case 'CRITICAL':
        AlertComponent = DangerAlert;
        break;
      default:
        AlertComponent = WarningAlert;
        break;
    }
    return { AlertComponent, message: log.message };
  }, [log]);

  if (!data) return null;

  return <data.AlertComponent>{data.message}</data.AlertComponent>;
};
